<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản đi đã ban hành
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class=" margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div class="flex-row margin-right-40">
                      <span class="style-fullWidth label-input margin-right-10 no_wrap">Quan trọng: </span>
                      <input
                        style="display: none"
                        type="checkbox"
                        ref="starCheckbox"
                        v-model="isStar"
                      >
                      <div class="theTitle__star" @click="isStarChange">
                        <i :class="{'fas fa-star' : isStar, 'fal fa-star' : !isStar}" />
                      </div>
                    </div>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto"-->
<!--                      >Ngày văn bản:-->
<!--                      </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="docDateRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="right"-->
<!--                        :clearable="false"-->
<!--                        @change="filterByDocDateRange"-->
<!--                      >-->
<!--                      </el-date-picker>-->
<!--                    </div>-->
                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày văn bản:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromDocDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toDocDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      ></el-date-picker>
                    </div>

                  </template>
                  <template #advance>
                    <dabanhanh-advance-search
                      :sortList="sortList"
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      :isEnableSearchTdhvpDoc="true"
                      :isEnableSearchLockedRole="true"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                      @searchTdhvpDoc="searchTdhvpDoc"
                      @searchLockedRoleDocOut="searchLockedRoleDocOut"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle--hasStar margin-right-15">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right ">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('createTime')"
                  >
                    Ngày tạo
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'createTime'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between clickable"
                    @click="viewDetailDocs(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle--hasStar margin-right-15">
                        <div class="flex-row flex__between">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <i
                            class="fas fa-file color__silver"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                          <div class="theTitle__star">
                            <i
                              :class="{'fal fa-star': !item.isStar, 'fas fa-star': item.isStar}"
                              @click.stop="changeStar(item)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Đã ban hành bản giấy"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isBanHanhBanGiay"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Không có tài liệu đính kèm"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isNotFileDinhKem"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div
                          class="theQuickAction flex-row flex__right"
                        >
                        <el-tooltip content="In phiếu xử lý" placement="top">
                          <i
                            @click.stop="inPhieuTrinhKi(item)"
                            class="action-icon bgAmbient__green clickable fas fa-print"
                          ></i>
                        </el-tooltip>
                        </div>
                        <div class="flex-row flex__right">
                          <i
                            class="cellIcon color__silver fas fa-file-import"
                          ></i>
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                          item.createTime | dateFormatter({ nullValue: "-" })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
            <chosen-file-type-dialog
              v-if="isOpenChosenFileTypeDialog"
              @closeDialog="isOpenChosenFileTypeDialog= false"
              @exportResult="exportResult"
              :is-open="true">
            </chosen-file-type-dialog>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import outGoingDocSevice from "../../services/outgoingDocService";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import BreakWordSpan from "../adminstration/ketluan/break-word-span";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import {EventBus} from "../../event-bus.js";
  import dateUtils from "../../dateUtils";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import buildAttachmentURL from "../../filters/buildAttachmentURL";
  import DabanhanhAdvanceSearch from "./components/dabanhanh-advance-search";
  import h from "../../services/h";
  import chosenFileTypeDialog from "./chosenFileTypeDialog";
  import vbDocUserService from "../../services/vbDocUserService";
  import vbUtils from "../../services/doc/vbUtils";
  import {mapActions, mapGetters, mapState} from "vuex";

  export default {
    components: {
      chosenFileTypeDialog,
      BreakWordSpan,
      DabanhanhAdvanceSearch,
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import("../../components/main/sub-header.vue"),
      SortCaret: () => import("./SortCaret")
    },

    mixins: [vbAttachmentTokenMixin],

    filters: {dateFormatter, buildAttachmentURL},

    data() {
      return {
        isOpenChosenFileTypeDialog:false,
        sortList:[],
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        perfectScrollbarSetting: {maxScrollbarLength: 350},

        outgoingDocs: [],

        page: 0,
        size: 10,
        advanceSearchForm: {},
        sort: null,
        order: null,
        keyword: null,
        docDateRange: [null, null],
        fromDocDate: null,
        toDocDate: null,
        isStar: false
      };
    },

    mounted() {
      EventBus.$on(this.currentRoute, options => {
        this.doSearch();
      });
    },

    computed: {
      currentRoute() {
        return this.$route.path.split("/")[3];
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      ...mapState("outgoingDocs", ["eventData"]),
      ...mapGetters("outgoingDocs", ["requiresListReload"]),
    },

    watch: {
      isOpenDialogCreate: function (newValue) {
        newValue && (this.isEnableDialogCreate = newValue);
      },
      isOpenAdvanceSearchDialog: function (newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      },
      eventData(newEvent) {
        if (this.requiresListReload) {
          console.log(`Reloading list due to event ${newEvent.action}`);
          this.doSearch()
          this.clearEvent(); // Reset the event after handling
        }
      }
    },

    created() {
      console.log('reload')
      this.initQuery();
      this.setDefaultDocDateRange();
      this.filterByDocDateRange();
    },

    methods: {
      ...mapActions("outgoingDocs", ["clearEvent"]),

      searchTdhvpDoc() {
        this.$router.push({
          name: "tdhvpDocOutVtIndex",
          params: this.$route.params
        });
      },

      searchLockedRoleDocOut() {
        this.$router.push({
          name: "lockedRoleDocOutIndex",
          params: this.params
        });
      },

      isVbDienTu(item){
        if(item.eFlag&&item.eFlag==='1'){
          return true;
        }else {
          return false;
        }
      },
      inPhieuTrinhKi(item) {
        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.IN_PHIEU.VB_DI;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.id})}`,
        );
      },
      chosenFileType(){
        this.isOpenChosenFileTypeDialog = true
      },
      exportResult(item) {
        this.isOpenChosenFileTypeDialog = false
        this.exportSearchResult(item,'VB_DA_BAN_HANH')
      },

      initQuery() {
        if (this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU){
          this.sort = this.$route.query.sort || "createTime";
        }
        else {
          this.sort = this.$route.query.sort || "updateTime";
        }
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          keyword: this.$route.query.keyword || undefined,
          fromDocDate: this.$route.query.fromDocDate
            ? parseInt(this.$route.query.fromDocDate)
            : undefined,
          toDocDate: this.$route.query.toDocDate
            ? parseInt(this.$route.query.toDocDate)
            : undefined,
          docCode: this.$route.query.docCode || undefined,
          quote: this.$route.query.quote || undefined,
          fileContent: this.$route.query.fileContent || undefined,
          docTypeId: this.$route.query.docTypeId || undefined,
          bookId: this.$route.query.bookId || undefined,
          otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
          receiveDeptId: this.$route.query.receiveDeptId || undefined,
          isStar: this.$route.query.isStar === "1" ? 1 : 0
        };
        this.keyword = this.advanceSearchForm.keyword;
        this.isStar = !!+this.$route.query.isStar;
        this.initDocDateRange();
      },

      buildQuery() {
        return utils.merge(
          {sort: this.sort || "updateTime", order: this.order || "desc"},
          this.advanceSearchForm
        );
      },

      initDocDateRange() {
        if (
          this.advanceSearchForm.fromDocDate ||
          this.advanceSearchForm.toDocDate
        ) {
          this.docDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
            dateUtils.toMoment(this.advanceSearchForm.toDocDate)
          ];
        } else {
          this.docDateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
          );
          this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
          this.advanceSearchForm.toDocDate = defaultTimeRange[1];
        }
      },

      simpleSearch(keyword) {
        this.keyword = this.advanceSearchForm.keyword = keyword;
        this.advanceSearchForm.docCode = undefined;
        this.advanceSearchForm.quote = undefined;
        this.advanceSearchForm.fileContent = undefined;
        this.advanceSearchForm.docTypeId = undefined;
        this.advanceSearchForm.bookId = undefined;
        this.advanceSearchForm.receiveDeptId = undefined;
        this.advanceSearchForm.otherReceivePlaces = undefined;
        this.doSearch();
      },

      // filterByDocDateRange() {
      //   this.advanceSearchForm.fromDocDate =
      //     this.docDateRange && this.docDateRange[0]
      //       ? this.docDateRange[0].getTime()
      //       : undefined;
      //   this.advanceSearchForm.toDocDate =
      //     this.docDateRange && this.docDateRange[1]
      //       ? this.docDateRange[1].getTime()
      //       : undefined;
      //   this.doSearch();
      // },

      setDefaultDocDateRange() {
        // Lấy ngày đầu tiên của năm hiện tại
        const startDate = new Date(new Date().getFullYear(), 0, 1);

        // Đặt giá trị mặc định cho fromDocDate
        this.fromDocDate = startDate;

      },

      filterByDocDateRange() {
        // Kiểm tra xem cả hai fromDocDate và toDocDate đều null hoặc không đúng định dạng
        const fromDateValid = this.isValidDate(this.fromDocDate);
        const toDateValid = this.isValidDate(this.toDocDate);

        if ((this.fromDocDate === null || !fromDateValid) && (this.toDocDate === null || toDateValid)) {
          // Nếu fromDocDate không hợp lệ hoặc null và toDocDate hợp lệ, chỉ reset lại fromDocDate
          this.fromDocDate = new Date(new Date().getFullYear(), 0, 1);
        } else if ((this.toDocDate === null || !toDateValid) && (this.fromDocDate === null || fromDateValid)) {
          // Nếu toDocDate không hợp lệ hoặc null và fromDocDate hợp lệ, chỉ reset lại toDocDate
          this.toDocDate = new Date(new Date().getFullYear(), 11, 31);
        } else if (this.fromDocDate > this.toDocDate) {
          // Nếu fromDocDate lớn hơn toDocDate, đảm bảo rằng fromDocDate nhỏ hơn hoặc bằng toDocDate
          this.fromDocDate = new Date(new Date().getFullYear(), 0, 1);
          this.toDocDate = new Date(new Date().getFullYear(), 11, 31);
        }

        this.advanceSearchForm.fromDocDate = this.fromDocDate ? this.fromDocDate.getTime() : undefined;
        this.advanceSearchForm.toDocDate = this.toDocDate ? this.toDocDate.getTime() : undefined;
        this.doSearch();
      },

      isValidDate(date) {
        return date instanceof Date && !isNaN(date);
      },

      daysInMonth(month) {
        return new Date(new Date().getFullYear(), month + 1, 0).getDate();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.sortList=event.sortList
        this.advanceSearchForm.keyword = undefined;
        this.keyword = null;
        this.advanceSearchForm.priorityId =
          advanceSearchForm.priorityId || undefined;
        this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
        this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
        this.advanceSearchForm.fileContent =
          advanceSearchForm.fileContent || undefined;
        this.advanceSearchForm.docTypeId =
          advanceSearchForm.docTypeId || undefined;
        this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
        this.advanceSearchForm.receiveDeptId =
          advanceSearchForm.receiveDeptId || undefined;
        this.advanceSearchForm.otherReceivePlaces =
          advanceSearchForm.otherReceivePlaces || undefined;
        this.advanceSearchForm.sortList =
          event.sortList || undefined;
        this.doSearch();
      },

      doSort(sort) {
        this.sort = sort;
        this.order =
          sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
        this.doSearch();
      },

      doSearch() {
        this.$router.replace({
          name: this.$router.name,
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.outgoingDocs = [];
        this.page = 0;
        this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      async list() {
        let pageable
        if(this.sortList&&this.sortList.length>0){

          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: this.page,
            size: this.size,
            sort: sort
          };
        }else {
          pageable= {
            page: this.page,
            size: this.size,
            sort: [this.sort, this.order].join(",")
          };
        }


        let advanceSearchForm = utils.merge(this.advanceSearchForm, {
          status: constants.OUTGOING_DOC_STATUS.DABANHANH
        });

        let items = null;
        await outGoingDocSevice
          .listChoBanHanh2(advanceSearchForm, pageable)
          .then(response => {
            items = response.data;
          })
        await vbDocUserService.getAllVbIsStarByUserDeptRole(this.userDeptRoleId)
          .then(response => {
            const vbDocIdsIsStarMap = response.data;

            for(let i = 0; i < items.length; i++) {
              items[i].isStar = 0;
              for(let key in vbDocIdsIsStarMap) {
                if (key === items[i].id) {
                  items[i].isStar = vbDocIdsIsStarMap[key]
                }
              }
            }
            this.outgoingDocs.push(...items);
            this.outgoingDocs = vbUtils.searchAndSort(advanceSearchForm.keyword, this.outgoingDocs);
          })
        return items;
      },
      exportSearchResult(fileType,name) {
        let pageable
        if(this.sortList&&this.sortList.length>0){

          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: 0,
            size: 1000,
            sort: sort
          };
        }else {
          pageable= {
            page: 0,
            size: 1000,
            sort: [this.sort, this.order].join(",")
          };
        }


        let advanceSearchForm = utils.merge(this.advanceSearchForm, {
          status: constants.OUTGOING_DOC_STATUS.DABANHANH
        });
        let params = utils.merge(advanceSearchForm, pageable)
        params.userId=this.$store.getters.userDeptRole.userId;
        params.deptId=this.$store.getters.userDeptRole.deptId;
        params.roleId=this.$store.getters.userDeptRole.roleId;
        params.positionId = this.$store.getters.userDeptRole.positionId;
        params.fileType = fileType
        params.name = name

        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_CHO_BAN_HANH;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
        );

        // return outGoingDocSevice
        //   .listChoBanHanh2(advanceSearchForm, pageable)
        //   .then(response => {
        //     let items = response.data;
        //     items && this.outgoingDocs.push(...items);
        //     return items;
        //   });
      },

      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
          ? "lv1"
          : "lv4";
      },

      isShowPiority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
      },

      viewDetailDocs(item) {
        item.isSeen = 1;
        this.$router.push({
          name: "vbDaBanHanhDetail",
          params: {userDeptRoleId: this.userDeptRoleId, id: item.id},
          query: this.$route.query
        });
      },

      isStarChange(value) {
        this.$refs.starCheckbox.click();
        const isStar = this.$refs.starCheckbox.checked ? 1 : 0;
        this.advanceSearchForm.isStar = isStar;
        this.doSearch();
      },

      changeStar(item) {
        const isStar = item.isStar === 1 ? 0 : 1

        vbDocUserService.setStar({
          vbDocId: item.id,
          userDeptRoleId: this.userDeptRoleId,
          isStar: isStar
        })
          .then(() => {
            item.isStar = isStar

            // Nếu đang filter theo văn bản có dấu sao thì sẽ reload trang nếu có thay đổi dấu sao của 1 văn bản
            if(this.isStar) {
              this.doSearch();
            }
          })
          .catch(() => {
            console.log('Không thể đánh dấu sao cho văn bản!')
          })
      }
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
  .eIcon{
    border: solid 1px #007aff;
    border-radius: 2px;
    padding: 0px 3px;
    font-size: 11px;
    color: goldenrod;
    margin-left:2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/VbDaBanHanhIndex.vue